import React, { useContext } from 'react'
import Header from './Header'
import Footer from './Footer'
import styled from 'styled-components'
import { PublicIndexContext } from '../context/PublicIndexContext'
import PowerOfAttorney from './PowerOfAttorney'
import SignedPowerOfAttorney from './SignedPowerOfAttorney'

const Index = () => {
  const publicIndexContext = useContext(PublicIndexContext)
  const StyledDiv = styled.div`
        a:visited {
            color: ${publicIndexContext.organizationData.linkColor};
        }
        a:link {
            color: ${publicIndexContext.organizationData.linkColor};
        }
        a:active {
            color: ${publicIndexContext.organizationData.linkColor};
        }
    `

  return (
    <div style={{ background: publicIndexContext.organizationData.backgroundColor }} className="backgroundDiv">
      <div className="container">
        <div className="row pb-4" style={publicIndexContext.style.header}>
          <div className="col">
            <Header />
          </div>
        </div>
        <StyledDiv>
          {publicIndexContext.unSignedPowerOfAttorney &&
                        <PowerOfAttorney />
          }
          {publicIndexContext.signedPowerOfAttorney &&
                        <SignedPowerOfAttorney />
          }
          <Footer />
        </StyledDiv>
      </div>
    </div>
  )
}

export default Index
